import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import mcposter from '../assets/mcposter.png'
import './Login.css'
import {toast} from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import Cookies from "js-cookie";
import { base_url_toonflix } from '../Services/api';


// mcfunny.madfunny.co.za
// https://madfunny.co.za/DoiRedirect?subscription_id=2123446562&msisdn=27680633950&ext_ref=testing_ref
const Otp = ({ serviceName }) => {

  const ani = Cookies.get('number')

  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
    const [input4, setInput4]=useState('')

  const [loading, setLoading] = useState(false);
  const [tVal, setTVal] = useState(null)
  const [show,setShow] = useState(false);


  const urlParams = new URLSearchParams(window.location.search);
  const otpId = urlParams.get('id');

  const [time, setTime] = useState(60);
  const pack = Cookies.get('pack');
  var extId = Cookies.get('extId')
 


  const [number, setNumber] = useState();

  const navigate = useNavigate()

  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => setTime(time - 1), 1000);
      return () => clearTimeout(timer);
    }
    else {
      Cookies.remove('extId');
      Cookies.remove('number')
      Cookies.remove('pack')

      navigate(`/subscribe`)
    }
  }, [time]);

   const customStyles = {
      control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color here
        boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none', // Optional: Add box shadow
        '&:hover': {
          borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color on hover
        },
      
      }),
      // You can customize other parts of the select component as well
    };

    const getScript = async () => {
  setLoading(true);

  try {

    const res = await axios.post(
      `${base_url_toonflix}/api/v1/evina/script`,
      {
        serviceName: "MadFunny",
        extId: extId,
      }
    );

    // console.log(res.data, "==raw response==");

    // parse once, reuse everywhere
    const parsed = typeof res.data?.response === 'string'
      ? JSON.parse(res.data.response)
      : res.data?.response;

    // console.log(parsed, "==parsed response==");

    const scriptContent = parsed?.s;
    const token = parsed?.t;

    // console.log(scriptContent, "==script content==");
    // console.log(token, "==token==");

   
    setTVal(token || "");

    if (!scriptContent) {
      console.log("No script content found");
      return;
    }

    let top_head = document.getElementsByTagName("head")[0];
    let anti_script = document.createElement("script");

    anti_script.innerHTML = scriptContent;
    top_head.insertBefore(anti_script, top_head.firstChild);

    const event = new Event("DCBProtectRun");
    document.dispatchEvent(event);

    document.addEventListener("gateway-load", (event) => {
      console.log(event, "EVENT LOADED");
    });

  } catch (error) {
    console.error("Error fetching script", error);

    const status = error?.response?.status;
    const msg = error?.response?.data?.message;

    if (status === 400) {
      console.log("Invalid script request payload:", msg);
    } else if (status === 500) {
      console.log("Server error generating script:", msg);
    }

  } finally {
     setLoading(false);
        setShow(true);
  }
};


      
      
          useEffect(()=>{
            getScript()
          },[])

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   const otp = input1 + input2 + input3 + input4;
  //   console.log(otp.length)
  //   if (otp.length < 4) {
  //     toast.warn("Entrez d'abord OTP !!");
  //     return;
  //   }

  //   try {

  //     const res = await axios.post(`${base_url_toonflix}/api/v1/matched-otp`, {
  //       otp,
  //       otpId,
  //       packType: pack,
  //       extId,
  //       t: tVal,
  //       serviceName: "MadFunny",
  //       msisdn: ani,
  //     });

  //     console.log(res.data)

  //     if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
  //       toast.success(res.data?.message || "OTP validé avec succès !!");
  //       navigate(`/redirect`)
  //     } else {
  //       toast.error(res.data?.message || "Une erreur s'est produite");
  //       navigate('/subscribe');
  //     }

  //   }
  //   catch (err) {
  //     console.log(err)

  //     const status = err?.response?.status;
  //     console.log(status, "==status===")
  //     const msg = err?.response?.data?.message;

  //     if (status === 400) {
  //       toast.error(msg || "OTP invalide, veuillez réessayer.");
  //       navigate('/subscribe');
  //     } else if (status === 500) {
  //       toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
  //       navigate('/subscribe');
  //     } else {
  //       toast.error(msg || "Une erreur s'est produite");
  //     }
  //   }

  //   handleClear()

  // }


  const handleSubmit = async (e) => {
    e.preventDefault()
    const otp = input1 + input2 + input3 + input4;
    console.log(otp.length)
    if (otp.length < 4) {
      toast.warn("Entrez d'abord OTP !!");
      return;
    }

    try {

      const res = await axios.post(`${base_url_toonflix}/api/v1/matched-otp`, {
        otp,
        otpId,
        packType: pack,
        extId,
        t: tVal,
        serviceName: "MadFunny",
        msisdn: ani,
      });

      console.log(res.data)

      if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {
        toast.success(res.data?.message || "OTP validé avec succès !!");
        navigate(`/redirect?msisdn=${ani}`);
      } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {
        toast.info(res.data?.message || "Facturation en attente.");
      } else {
        toast.error(res.data?.message || "Une erreur s'est produite");
        navigate('/subscribe');
      }

    }
    catch (err) {
      console.log(err)

      const status = err?.response?.status;
      console.log(status, "==status===")
      const msg = err?.response?.data?.message;
      const code = err?.response?.data?.code;

      if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
        toast.info(msg || "Abonnement déjà actif.");
        navigate(`/redirect?msisdn=${ani}`);
      } else if (status === 400) {
        toast.error(msg || "OTP invalide, veuillez réessayer.");
        navigate('/subscribe');
      } else if (status === 500) {
        toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
        navigate('/subscribe');
      } else {
        toast.error(msg || "Une erreur s'est produite");
      }
    }

    handleClear()

  }

  const handleClear = () => {
    setInput1('');
    setInput2('');
    setInput3('');
    setInput4('');

  }

  const handleInputChange = (e, setInput, nextFieldId, prevFieldId) => {
    const { value } = e.target;
    if (/^\d$/.test(value) || value === '') {
      setInput(value);
      if (value && nextFieldId) {
        document.getElementById(nextFieldId).focus();
      }
    }
  };

  const handleKeyDown = (e, prevFieldId) => {
    if (e.key === 'Backspace' && !e.target.value && prevFieldId) {
      document.getElementById(prevFieldId).focus();
    }
  };

  return (
    <div className='login-container' style={{ fontFamily: "'DM Sans', sans-serif" }}   >

      <div className='w-full h-screen flex justify-center items-center' style={{ backdropFilter: 'blur(10px)', }}>
        <form onSubmit={handleSubmit} className=' max-w-lg rounded-md flex flex-col justify-center items-center' style={{
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.2)', // Set a transparent white background
          backdropFilter: 'blur(10px)',
          border: '1px solid grey',
          padding: '20px',
        }}>
          <h1 className='text-white text-center text-2xl font-bold  md:text-4xl  mt-5'>Validation OTP


          </h1>
          <p className='text-white text-xl font-semibold mt-1 font-medium '>
            Saisissez l'OTP envoyé à votre numéro de mobile :
          </p>
          <br />
          <div className='flex justify-center  gap-2'>
            <input id="input1" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxlength="1" value={input1} onChange={(e) => handleInputChange(e, setInput1, 'input2', null)}
              onKeyDown={(e) => handleKeyDown(e, null)} />
            <input id="input2" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxlength="1" value={input2} onChange={(e) => handleInputChange(e, setInput2, 'input3', 'input1')}
              onKeyDown={(e) => handleKeyDown(e, 'input1')} />
            <input id="input3" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxlength="1" value={input3} onChange={(e) => handleInputChange(e, setInput3, 'input4', 'input2')}
              onKeyDown={(e) => handleKeyDown(e, 'input2')} />
            <input id="input4" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxlength="1" value={input4} onChange={(e) => handleInputChange(e, setInput4, null, 'input3')}
              onKeyDown={(e) => handleKeyDown(e, 'input3')} />
          </div>

          <br />
          <p className='text-black font-bold text-xl' >OTP expirera dans {time}</p>

          <button
            disabled={loading}
            id="otp-send"
            type="submit"
            className=" text-white mt-2 w-48 bg-[#0D6EFD] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-7 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
            {loading ? "Chargement..." : "s'abonner"}
          </button>
           

            <p 
  onClick={() => navigate('/tnc')} 
  className="text-black font-bold text-center mt-4 underline cursor-pointer mb-3"
>
  Conditions générales
</p>
 <span className='text-xs font-semibold w-full text-center' >• Désinscription gratuite à tout moment : composez #303#10#.</span>

        <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
             </form>

             

      </div>
      {/* <ToastContainer /> */}
 
    </div>

    

  );
};

export default Otp;
